import pista1 from '../assets/pista_1.mp3'
import pista2 from '../assets/pista2.mp3'
import pista3 from '../assets/pista_3.mp3'
import foto1 from '../assets/foto1.png'
import foto2 from '../assets/foto2.jpeg'
import foto3 from '../assets/foto3.jpg'

export const songs = [

  {
    id: 1,
    title: "sera prudente",
    artist: "Alma Morena",
    duration: "4:20",
    cover: foto2,
    audioUrl: pista2
  },
  {
    id: 2,
    title: "no debes pensar en mi",
    artist: "Alma Morena",
    duration: "3:55",
    cover: foto3,
    audioUrl: pista3
  }
] 